/** Deep links into Remediation Hub (requests list + detail drawer). */

export const REMEDIATION_HUB_PATH = "/remediation-hub";
export const REQUEST_URL_PARAM = "r_request";

export const buildRemediationHubUrl = (requestId) => {
  if (typeof window === "undefined") {
    return requestId != null
      ? `${REMEDIATION_HUB_PATH}?${REQUEST_URL_PARAM}=${requestId}`
      : REMEDIATION_HUB_PATH;
  }
  const params = new URLSearchParams(window.location.search);
  if (requestId != null) {
    params.set(REQUEST_URL_PARAM, String(requestId));
  } else {
    params.delete(REQUEST_URL_PARAM);
  }
  const qs = params.toString();
  return qs ? `${REMEDIATION_HUB_PATH}?${qs}` : REMEDIATION_HUB_PATH;
};

export const readRequestIdFromUrl = () => {
  if (typeof window === "undefined") return null;
  const raw = new URLSearchParams(window.location.search).get(REQUEST_URL_PARAM);
  if (!raw) return null;
  const id = Number(raw);
  return Number.isFinite(id) ? id : null;
};

export const clearRequestIdFromUrl = () => {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    if (!params.has(REQUEST_URL_PARAM)) return;
    params.delete(REQUEST_URL_PARAM);
    const qs = params.toString();
    const next = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`;
    window.history.replaceState(null, "", next);
  } catch (_e) {
    /* no-op */
  }
};

export const navigateToRemediationHub = (requestId) => {
  window.location.assign(buildRemediationHubUrl(requestId));
};

/** Prefer existing active request when create was deduplicated. */
export const resolveHubRequestIds = (succeeded = []) =>
  succeeded
    .map((s) => s.deduped_by ?? s.request_id)
    .filter((id) => id != null);
